import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useState } from "react";
import tw from "tailwind-styled-components";
import { v4 as uuidv4 } from "uuid";
const Container = tw.span`
  inline-flex
  items-center
  justify-center
  gap-1
`;
const Input = tw.input`
  rounded-[2px]
  appearance-none
  !ring-[0]

  ${({ $disabled })=>$disabled ? "opacity-50" : ""}
`;
const Label = tw.label`
  text-white
  text-opacity-70
  font-normal

  ${({ $disabled })=>$disabled ? "opacity-50" : ""}
`;
const fontSizes = {
    sm: "text-sm",
    md: "text-md"
};
const SCheckbox = ({ label, checked: passedChecked = false, onChange = ()=>{}, isControlled = true, fontSize = "md", disabled = false })=>{
    const [localChecked, setLocalIsChecked] = useState(passedChecked);
    const checked = isControlled ? passedChecked : localChecked;
    const id = `label-${uuidv4()}`;
    const $fontSize = fontSizes[fontSize];
    const _onChange = (e)=>{
        onChange(label, e.target.checked);
        setLocalIsChecked(!localChecked);
    };
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Input, {
                id: id,
                type: "checkbox",
                checked: checked,
                onChange: _onChange,
                disabled: disabled,
                $disabled: disabled
            }),
            /*#__PURE__*/ _jsx(Label, {
                htmlFor: id,
                className: $fontSize,
                $disabled: disabled,
                children: label
            })
        ]
    });
};
export default SCheckbox;
